module.exports = __webpack_public_path__ + "static/media/ceph.0f383295.jpg";